import {
  convertToHex,
  determineThemeKeyFromEditColorsLinkId,
} from 'builder/util/themeUtils';

interface useHandleColorSaveProps {
  site: Site;
  updateSite: (site: Site) => void;
}

export default function useHandleColorSave(
  props: useHandleColorSaveProps,
  activeColor: string,
  activeColorName: string,
  activeColorType: string | 'Custom' | 'Default' | 'Text' | 'Brand',
  editColorsLinkId: string | undefined
) {
  const saveSite = (updatedSite: Site) => {
    props.updateSite(updatedSite);
  };

  const handleDefaultColorType = () => {
    const updatedSite: Site = {
      ...props.site,
      theme: {
        ...props.site.theme,
        colors: {
          ...props.site.theme.colors,
          [activeColorName.toLowerCase()]: activeColor,
        },
      },
    };
    saveSite(updatedSite);
  };

  const determineExistingColors = (themeKey: string) => {
    return (
      props.site.theme[themeKey]?.colors?.custom ||
      props.site.theme.colors.custom
    );
  };

  const handleCustomColorType = () => {
    const themeKey =
      determineThemeKeyFromEditColorsLinkId(editColorsLinkId) || 'customTheme1';
    const convertedColorValue = activeColor.startsWith('rgb')
      ? convertToHex(activeColor)
      : activeColor;

    const updatedCustomColor = {
      id: convertedColorValue,
      type: activeColorType,
      name: activeColorName,
      value: convertedColorValue,
    };

    const existingColors = determineExistingColors(themeKey);
    const updatedCustomColors = existingColors.map(c =>
      c.name === activeColorName ? updatedCustomColor : c
    );

    if (!existingColors.some(c => c.name === activeColorName)) {
      updatedCustomColors.push(updatedCustomColor);
    }

    const updatedSite: Site = {
      ...props.site,
      theme: {
        ...props.site.theme,
        [themeKey]: {
          ...props.site.theme[themeKey],
          colors: {
            ...props.site.theme[themeKey]?.colors,
            custom: updatedCustomColors,
          },
        },
      },
    };

    saveSite(updatedSite);
  };

  const handleNewColorType = () => {
    let convertedColorValue = activeColor;
    if (activeColor.startsWith('rgb')) {
      convertedColorValue = convertToHex(activeColor);
    }
    const newColor: Color = {
      id: convertedColorValue,
      type: 'Custom',
      value: convertedColorValue,
      name: activeColorName,
    };
    const newColorArray = [...props.site.theme.colors.custom, newColor];
    const newSite: Site = {
      ...props.site,
      theme: {
        ...props.site.theme,
        colors: {
          ...props.site.theme.colors,
          custom: newColorArray,
        },
      },
    };
    saveSite(newSite);
  };

  if (activeColorType === 'Default') {
    handleDefaultColorType();
  } else if (activeColorType === 'Custom') {
    handleCustomColorType();
  } else if (activeColorType === undefined || !activeColorType) {
    handleNewColorType();
  }
}
